import { apiClient } from './api'

export type ProposalKind = 'risk' | 'issue' | 'assumption' | 'dependency' | 'decision' | 'action'
export type Level = 'High' | 'Medium' | 'Low'

export interface Proposal {
  kind: ProposalKind
  title: string
  description: string
  owner: string | null
  due_date: string | null
  probability: Level | null
  impact: Level | null
  quote: string
  duplicate_of?: string | null
}

export interface Extraction { summary: string; items: Proposal[]; dropped: number }

export const meetingNotesService = {
  async extract(projectId: number, notes: string, meetingDate?: string): Promise<Extraction> {
    const { data } = await apiClient.post<Extraction>(`/api/v1/projects/${projectId}/meeting-notes/extract`, {
      notes, meeting_date: meetingDate || null,
    })
    return data
  },
  async apply(projectId: number, items: Proposal[], meetingDate?: string): Promise<{ total: number; added: Record<ProposalKind, number> }> {
    const { data } = await apiClient.post(`/api/v1/projects/${projectId}/meeting-notes/apply`, {
      items: items.map(({ duplicate_of: _d, ...rest }) => rest), meeting_date: meetingDate || null,
    })
    return data
  },
}
